// 需要同时使用新的服务器和旧的服务器，
export let oceanlabIds_old = new Map()
oceanlabIds_old.set('PRMSL', {
    layerId: '100098',
    zLayer: 0,
    //起报时效
    time: '00:00:00',
    //预报间隔
    fgap: 3,
    //预报天数
    fday: 3
})
oceanlabIds_old.set('WIND10M', {
    layerId: '100097',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 3
})
oceanlabIds_old.set('WAVEL', {
        layerId: '100135',
        zLayer: 0,
        time: '00:00:00',
        fgap: 1,
        fday: 5
    })
    //海浪的等值面
oceanlabIds_old.set('WAVE', {
    // layerId: '100109',
    layerId: '100131',
    zLayer: 0,
    time: '00:00:00',
    fgap: 1,
    fday: 5
})
oceanlabIds_old.set('sf', {
    // 表层洋流，
    layerId: '100106',
    // layerId: '100100',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})

oceanlabIds_old.set('sfP', {
    layerId: '100125',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})

oceanlabIds_old.set('sst', {
    // 表层水温
    layerId: '100105',
    // layerId: '100099',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_old.set('sstL', {
    // 暂时用
    layerId: '100113',
    // layerId: '100115',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_old.set('ssta', {
    layerId: '100116',
    zLayer: 0,
    time: '00:00:00',
    fgap: 24,
    fday: 1
})
oceanlabIds_old.set('ssh', {
    layerId: '100101',
    zLayer: 1,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_old.set('sshL', {
    layerId: '100114',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_old.set('ssha', {
    layerId: '100117',
    zLayer: 0,
    time: '00:00:00',
    fgap: 24,
    fday: 1
})
oceanlabIds_old.set('chla', {
    layerId: '100103',
    zLayer: 0,
    time: '00:00:00',
    fgap: 24,
    fday: 1
})
oceanlabIds_old.set('CURRENT25P', {
    layerId: '100124',
    zLayer: 10,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT50P', {
    layerId: '100124',
    zLayer: 15,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT100P', {
    layerId: '100124',
    zLayer: 20,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT150P', {
    layerId: '100124',
    zLayer: 22,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT200P', {
    layerId: '100124',
    zLayer: 23,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT300P', {
    layerId: '100124',
    zLayer: 25,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_old.set('CURRENT25', {
    layerId: '100100',
    zLayer: 10,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT50', {
    layerId: '100100',
    zLayer: 15,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT100', {
    layerId: '100100',
    zLayer: 20,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT150', {
    layerId: '100100',
    zLayer: 22,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT200', {
    layerId: '100100',
    zLayer: 23,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('CURRENT300', {
    layerId: '100100',
    zLayer: 25,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_old.set('TMP25', {
    layerId: '100099',
    zLayer: 10,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP50', {
    layerId: '100099',
    zLayer: 15,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_old.set('TMP100', {
    layerId: '100099',
    zLayer: 20,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP150', {
    layerId: '100099',
    zLayer: 22,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP200', {
    layerId: '100099',
    zLayer: 23,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP300', {
    layerId: '100099',
    zLayer: 25,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP25L', {
    layerId: '100115',
    zLayer: 10,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP50L', {
    layerId: '100115',
    zLayer: 15,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_old.set('TMP100L', {
    layerId: '100115',
    zLayer: 20,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP150L', {
    layerId: '100115',
    zLayer: 22,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP200L', {
    layerId: '100115',
    zLayer: 23,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('TMP300L', {
    layerId: '100115',
    zLayer: 25,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_old.set('fengxian', {
    layerId: '100098',
    zLayer: 0,
    time: '00:00:00'
})
oceanlabIds_old.set('WINDALARM', {
    layerId: '100110',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 3
})
oceanlabIds_old.set('WAVEALARM', {
    layerId: '100134',
    zLayer: 0,
    time: '00:00:00',
    fgap: 1,
    fday: 5
})



export let oceanlabIds_new = new Map()
oceanlabIds_new.set('PRMSL', {
    // layerId: '100098',
    layerId: '7',
    zLayer: 0,
    //起报时效
    time: '00:00:00',
    //预报间隔
    fgap: 3,
    //预报天数
    fday: 3
})
oceanlabIds_new.set('WIND10M', {
    // layerId: '100097',
    layerId: '3',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 3
})
oceanlabIds_new.set('WAVEL', {
        // layerId: '100135',
        layerId: '134',
        zLayer: 0,
        time: '00:00:00',
        fgap: 1,
        fday: 5
    })
    //海浪的等值面
oceanlabIds_new.set('WAVE', {
    // layerId: '100109',
    layerId: '133',
    zLayer: 0,
    time: '00:00:00',
    fgap: 1,
    fday: 5
})
oceanlabIds_new.set('sf', {
    layerId: '17',
    // 表面洋流 暂时
    // layerId: '73',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})

oceanlabIds_new.set('sfP', {
    // layerId: '100125',
    layerId: '73',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})

oceanlabIds_new.set('sst', {
    // 表温
    // layerId: '15',
    layerId: '15',
    // styles: 'ecsf_contour',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_new.set('sstL', {
    layerId: '15',
    styles: 'ecsf_contour',
    zLayer: 0,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_new.set('ssta', {
    layerId: '92',
    styles: 'ecsf_contour',
    zLayer: 0,
    time: '00:00:00',
    fgap: 24,
    fday: 1
})
oceanlabIds_new.set('ssh', {
    // layerId: '100101',
    layerId: '16',
    zLayer: 1,
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_new.set('sshL', {
    layerId: '16',
    zLayer: 0,
    styles: 'ecsf_contour',
    time: '00:00:00',
    fgap: 3,
    fday: 7
})
oceanlabIds_new.set('ssha', {
    layerId: '93',
    zLayer: 0,
    time: '00:00:00',
    fgap: 24,
    fday: 1
})
oceanlabIds_new.set('chla', {
    // layerId: '100103',
    layerId: '132',
    zLayer: 0,
    time: '00:00:00',
    fgap: 24,
    fday: 1
})
oceanlabIds_new.set('CURRENT25P', {
    // layerId: '100124',
    layerId: '73',
    zLayer: 10,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT50P', {
    // layerId: '100124',
    layerId: '73',
    zLayer: 15,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT100P', {
    // layerId: '100124',
    layerId: '73',
    zLayer: 20,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT150P', {
    // layerId: '100124',
    layerId: '73',
    zLayer: 22,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT200P', {
    // layerId: '100124',
    layerId: '73',
    zLayer: 23,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT300P', {
    // layerId: '100124',
    layerId: '73',
    zLayer: 25,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_new.set('CURRENT25', {
    layerId: '73',
    zLayer: 10,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT50', {
    layerId: '73',
    zLayer: 15,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT100', {
    layerId: '73',
    zLayer: 20,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT150', {
    layerId: '73',
    zLayer: 22,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT200', {
    layerId: '73',
    zLayer: 23,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('CURRENT300', {
    layerId: '73',
    zLayer: 25,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_new.set('TMP25', {
    // layerId: '100099',
    layerId: '71',
    // styles: 'ecsf_contour',
    zLayer: 0,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP50', {
    layerId: '71',
    zLayer: 0,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_new.set('TMP100', {
    layerId: '71',
    zLayer: 0,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP150', {
    layerId: '71',
    zLayer: 0,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP200', {
    layerId: '71',
    zLayer: 0,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP300', {
    layerId: '71',
    zLayer: 0,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP25L', {
    // layerId: '100115',
    layerId: '71',
    styles: 'ecsf_contour',
    zLayer: 10,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP50L', {
    layerId: '71',
    styles: 'ecsf_contour',
    zLayer: 15,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})

oceanlabIds_new.set('TMP100L', {
    layerId: '71',
    styles: 'ecsf_contour',
    zLayer: 20,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP150L', {
    layerId: '71',
    styles: 'ecsf_contour',
    zLayer: 22,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP200L', {
    layerId: '71',
    styles: 'ecsf_contour',
    zLayer: 23,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('TMP300L', {
    layerId: '71',
    styles: 'ecsf_contour',
    zLayer: 25,
    time: '12:00:00',
    fgap: 24,
    fday: 5
})
oceanlabIds_new.set('fengxian', {
    layerId: '100098',
    zLayer: 0,
    time: '00:00:00'
})
oceanlabIds_new.set('WINDALARM', {
        // layerId: '100110',
        layerId: '4',
        zLayer: 0,
        time: '00:00:00',
        styles: "ecsf_gfs_alarm",
        fgap: 3,
        fday: 3
    })
    // 大浪预警
oceanlabIds_new.set('WAVEALARM', {
    // layerId: '100134',
    layerId: '32',
    zLayer: 0,
    time: '00:00:00',
    styles: "ecsf_wave_alarm",
    fgap: 1,
    fday: 5
})


// WEBPACK FOOTER //
// ./src/utils/map/oceanIds.js